interface DotGridPatternProps {
	className?: string;
	/** Unique ID to prevent SVG pattern collisions when multiple instances exist on the same page */
	id?: string;
}

/**
 * Subtle dot-grid SVG pattern for hero/section backgrounds.
 * Uses currentColor for theming — apply text-* classes to control dot color.
 */
export function DotGridPattern({ className, id = "dot-grid" }: DotGridPatternProps) {
	return (
		<svg
			className={className}
			aria-hidden="true"
			width="100%"
			height="100%"
			xmlns="http://www.w3.org/2000/svg"
		>
			<defs>
				<pattern id={id} x="0" y="0" width="40" height="40" patternUnits="userSpaceOnUse">
					<circle cx="20" cy="20" r="1" fill="currentColor" opacity="0.12" />
				</pattern>
			</defs>
			<rect width="100%" height="100%" fill={`url(#${id})`} />
		</svg>
	);
}
